// extracted by mini-css-extract-plugin
export default {"columnTitle":"useHeaderColumnProps_columnTitle__dAMju","placeHolderShimmer":"useHeaderColumnProps_placeHolderShimmer__J-u1s"};